var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "app-modal-overlay",
    },
    [
      _c("div", { staticClass: "app-modal" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "app-modal-headline" }, [
          _vm._v(_vm._s(_vm.headline)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "app-modal-message" }, [
          _vm._v(_vm._s(_vm.message)),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app-modal-deco" }, [
      _c("div", { staticClass: "app-modal-deco-element" }),
      _vm._v(" "),
      _c("div", { staticClass: "app-modal-deco-element" }),
      _vm._v(" "),
      _c("div", { staticClass: "app-modal-deco-element" }),
      _vm._v(" "),
      _c("div", { staticClass: "app-modal-deco-element" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app-modal-actions" }, [
      _c("button", [_vm._v("OK")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }